import { computed, defineComponent } from 'vue'
import { getCurrencyOptions } from '@/data/currencies'
import SelectDropDown from '../select-dropdown'
import type { DataFormNode } from '../data-form/types'
import type { FormFieldOption, FormFieldOptions } from '@/form/useForm'
import type { IInputOption } from '../form/input/types'

export const SelectBox = defineComponent<{
  value?: any;
  dataRef?: DataFormNode<any>,
  options?: FormFieldOptions,
  type?: string;
  disabled?: boolean;
  locked?: boolean;
  compact?: boolean;
  invalidValuePlaceholder?: IInputOption | FormFieldOption
}>(
  (props) => {
    const currencyItems = getCurrencyOptions()

    const handleChange = (value: string) => {
      if (props.dataRef) {
        props.dataRef.setValue(value);
      }
    }

    const options = computed(() => {
      return props.options && props.options.items && props.options.items.length > 0 ? props.options : {
                items: currencyItems,
                search: { enabled: false }
              }
    })
    return () => {
      return (
        <div style={{}}>
          <SelectDropDown
            noCollapseIconWhenDisabled={true}
            noOpacityChangeWhenDisabled={true}
            disabled={props.locked || props.disabled}
            onValueChange={handleChange}
            size="xs"
            variant="gray"
            config={{
              noCollapseIconWhenDisabled: true,
              invalidValuePlaceholder: props.invalidValuePlaceholder
            }}
            options={options.value}
            value={props.value}
            dataRef={props.dataRef as any}
            type={'string'}
            style={[
              props.compact ? {
                borderLeft: 'none'
              } : {}
            ]}
          />
        </div>
      )
    }
  }
, { props: ['dataRef', 'value', 'type', 'options', 'disabled', 'locked', 'compact', 'invalidValuePlaceholder'] })
